import { Box, Center, Flex } from '@chakra-ui/react';
import { AddPulsIcon, EmptyContactIcon } from '@halo/ui-chat-react';
import { MyTrans } from '@halo/ui-react';
import CollapseIcon from './img/collapse.png';

interface EmptyContactProps {
  showCollapseChat?: boolean;
}

export function EmptyContact({ showCollapseChat }: EmptyContactProps) {
  return (
    <Flex pt="11" flexDir="column" align="center" justify="center" gap="1" fontSize="sm">
      <Box w="25" h="25">
        {showCollapseChat ? (
          <img width="100px" height="100px" src={CollapseIcon} alt="collapse" />
        ) : (
          <EmptyContactIcon />
        )}
      </Box>
      {showCollapseChat ? (
        <MyTrans i18nKey="chatList.noCollapsedChats" />
      ) : (
        <Flex flexWrap="wrap" gap="2" align="center" justify="center">
          <MyTrans
            i18nKey="chatList.tabTheIconToAddContacts"
            components={{
              wrap: <Center key="0" fontSize="sm" display="inline-flex" />,
              icon: <AddPulsIcon key="1" />,
            }}
          />
        </Flex>
      )}
    </Flex>
  );
}
